import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { AuthBase } from '../../base/services/auth-base';
import { CmsAuthApiService } from './cms-auth-api.service';

@Injectable({
  providedIn: 'root'
})
export class CmsAuthService extends AuthBase {
  protected apiUrl = environment.cmsApi;
  protected authRedirectUrl = 'auth';
  protected tokenName = 'mdtCmsToken';

  constructor(authApiService: CmsAuthApiService, router: Router) {
    super(authApiService, router);
  }
}
